import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Protected } from "@/components/layout/Protected";

import { VALIDATORS } from "@/toolbox/helpers/validation-rules";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Grid, Button, Autocomplete, FormHelperText, Select, InputLabel, Typography, TextField, Divider, InputAdornment, FormControlLabel, Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton, } from '@mui/material';

import { Props } from "./DecisionOc.type";

import { InputRef } from '@/components/common/Input/InputInterfaces';

import './DecisionOc-styles.css';
import FormGroup from '@mui/material/FormGroup';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

export const DecisionOc: React.FC<Props> = (props: Props): JSX.Element => {
   const inputRefs = useRef<Array<InputRef | null>>([]);
   const [loading, setLoading] = useState(false);

   const [value, setValue] = React.useState<Date | null>(
      new Date('2018-01-01T00:00:00.000Z'),
   );

   const usuarios = [
      { label: 'Todos' },
      { label: 'Usuario 1' },
      { label: 'Usuario 2' },
      { label: 'Usuario 3' },
      { label: 'Usuario 4' },
   ]

   const rowsContrato = [
   ]

   const handleSubmit = async (event: React.SyntheticEvent) => {
      event.preventDefault();
   }
   
   return (
      <Protected>
         <div style={{height:'100vh'}}>
         <form style={{ margin: '8px' }}>
            <Typography variant="h6" gutterBottom mb={3} className="tittle">
               SOLICITUDES DE OFERTA
            </Typography>
            <Grid container spacing={3} className={`e-mb-lg`} >

               <Grid item xs={12} sm={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                     <DatePicker
                        views={['year', 'month']}
                        label="Periodo y Mes"
                        minDate={new Date('2012-03-01')}
                        maxDate={new Date('2023-06-01')}
                        value={value}
                        onChange={(newValue) => {
                           setValue(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} helperText={null} />}
                     />
                  </LocalizationProvider>
               </Grid>

               <Grid item xs={12} sm={2}>
                  <Autocomplete
                     disablePortal
                     size='small'
                     id="combo-box-demo"
                     options={usuarios}
                     renderInput={(params) => <TextField {...params} label="Solicitado Por" />}
                  />
               </Grid>

               <Grid item xs={12} sm={2}>
                  <FormGroup>
                     <FormControlLabel control={<Checkbox  />} label="Ver Sólo Genéricas" />
                  </FormGroup>
               </Grid>

               <Grid item xs={12} sm={5} alignItems="center" >

                  <Button
                     type='submit'
                     variant='contained'
                     onClick={handleSubmit}
                     disabled={loading}
                     disableElevation
                     className='btn_save'
                  >
                     Visualizar
                  </Button>
               </Grid>

            </Grid>
         </form>

         <div className='bg-tittle'>
            <Typography
               mt={3}
               variant="h6"
               align='center'
               className='tittle-text'
            >Listado Solicitudes de Oferta
            </Typography>
         </div>


         <div>
            <Typography
               mt={1}
               mb={2}
               align='left'
               className='tittle-text2'
            >Periodo 20XX | Mes Junio
            </Typography>
         </div>

         <TableContainer component={Paper}>
            <Table aria-label="simple table">
               <TableHead>
                  <TableRow>
                     <TableCell>N°</TableCell>
                     <TableCell align="center">Numero</TableCell>
                     <TableCell align="center">Fecha</TableCell>
                     <TableCell align="center">Sol.Compra</TableCell>
                     <TableCell align="center">Descripción</TableCell>
                     <TableCell align="center">Opciones</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {rowsContrato.map((row, index) => (
                     <TableRow key={index} >
                        <TableCell component="th" scope="row">
                           {index + 1}
                        </TableCell>
                        <TableCell align="center">{row.numero}</TableCell>
                        <TableCell align="center">{row.Fecha}</TableCell>
                        <TableCell align="center">{row.Descripcion}</TableCell>
                        <TableCell align="center">{row.prioridad}</TableCell>
                        <TableCell align="center">
                           <IconButton
                              aria-label="delete"
                              className='btn_delete'
                           >
                              <DeleteIcon />
                           </IconButton>

                           <IconButton
                              aria-label="delete"
                              className='btn_delete'
                           >
                              <EditIcon />
                           </IconButton>

                        </TableCell>
                     </TableRow>
                  ))}
               </TableBody>
            </Table>
         </TableContainer>
         </div>
      </Protected>
   );
}